import { Tag, Tooltip } from 'antd'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

import { translateAuditAction } from 'src/utils'

type Props = {
  action: string
  maxWidth?: number
  style?: CSSProperties
}

export const AuditActionTag = ({ action, maxWidth = 180, style }: Props) => {
  const { t } = useTranslation()
  const rawAction = action.trim()
  const label = translateAuditAction(t, rawAction)

  if (!rawAction || !label) return null

  return (
    <Tooltip title={rawAction}>
      <Tag
        style={{
          marginInlineEnd: 0,
          maxWidth,
          fontSize: 10,
          lineHeight: '18px',
          paddingInline: 6,
          verticalAlign: 'middle',
          ...style
        }}
      >
        <span
          style={{
            display: 'block',
            maxWidth: maxWidth - 14,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {label}
        </span>
      </Tag>
    </Tooltip>
  )
}
